import React from "react";
import ReactDOM from "react-dom";
import AppContainer from "./container/app";

ReactDOM.render(
  <React.StrictMode>
    <AppContainer />
  </React.StrictMode>,
  document.getElementById("root")
);
